import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const deleteActivity = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.activities.delete(id));
